import { pick } from 'lodash-es'

const transformToPlatformInput = data =>
  pick(data, ['name', 'urlIdentificationRegex', 'urlNormalizationRegex'])

export default transformToPlatformInput
